import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const RETENTION_MS = 24 * 60 * 60 * 1000; // 24h purge window

export default function ExpiryCountdown({ createdAt, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);
  if (!createdAt) return null;
  const ms = new Date(createdAt).getTime() + RETENTION_MS - now;
  let label, tone;
  if (ms <= 0) {
    label = "purged";
    tone = "text-slate-400 bg-slate-100";
  } else {
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    label = h > 0 ? `auto-deletes in ${h}h ${m}m` : `auto-deletes in ${m}m`;
    tone = ms < 3600000 ? "text-red-600 bg-red-50" : ms < 6 * 3600000 ? "text-amber-600 bg-amber-50" : "text-slate-500 bg-slate-100";
  }
  return (
    <span data-testid="expiry-countdown" className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full whitespace-nowrap ${tone} ${className}`}>
      <Clock className="h-3 w-3 shrink-0" /> {label}
    </span>
  );
}
